{
  "name": "macrotide-web",
  "private": true,
  "version": "0.1.0",
  "type": "module",
  "engines": {
    "node": ">=22.12"
  },
  "scripts": {
    "shared": "cd ../.. && ./gradlew :shared:jsNodeProductionLibraryDistribution",
    "dev": "vite",
    "build": "tsc -b && vite build",
    "preview": "vite preview",
    "typecheck": "tsc -b",
    "lint": "eslint .",
    "test": "vitest run",
    "i18n:extract": "lingui extract",
    "i18n:compile": "lingui compile --typescript"
  },
  "dependencies": {
    "@lingui/core": "6.12.0",
    "@lingui/react": "6.12.0",
    "@mantine/core": "9.7.4",
    "@mantine/hooks": "9.7.4",
    "@mantine/notifications": "9.7.4",
    "@tanstack/react-query": "5.105.3",
    "@tanstack/react-router": "1.170.46",
    "macrotide-shared": "file:../../shared/build/dist/js/productionLibrary",
    "react": "19.3.1",
    "react-dom": "19.3.1",
    "recharts": "3.10.1"
  },
  "devDependencies": {
    "@eslint/js": "10.0.1",
    "@lingui/cli": "6.12.0",
    "@lingui/vite-plugin": "6.12.0",
    "@testing-library/react": "^16.3.3",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@vitejs/plugin-react": "6.2.1",
    "eslint": "10.14.0",
    "eslint-plugin-lingui": "0.16.0",
    "eslint-plugin-react-hooks": "7.1.1",
    "globals": "17.14.0",
    "jsdom": "^30.1.3",
    "typescript": "6.0.3",
    "typescript-eslint": "8.72.1",
    "vite": "8.3.5",
    "vitest": "5.1.0"
  }
}
